import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { keycloakGuard } from './core/guards/keycloak.guard';
import { CheckStatusComponent } from './pages/check-status/check-status.component';

export const routes: Routes = [
  {path: 'check-status', component: CheckStatusComponent},
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then((m) => m.DashboardRoutes),
      },
    ],
    canActivate: [keycloakGuard]
  },
  {
    path: 'gestione-psa',
    component: FullComponent,
    loadChildren: () =>
      import('./pages/psa/psa.routes').then(
        (m) => m.PsaRoutes
      ),
      canActivate: [keycloakGuard]
  },
  {
    path: 'lista-notifiche',
    component: FullComponent,
    loadChildren: () =>
      import('./pages/notifiche/notifiche.routes').then(
        (m) => m.NotificheRoutes
      ),
      canActivate: [keycloakGuard]
  },
    {
    path: 'lista-filiere',
    component: FullComponent,
    loadChildren: () =>
      import('./pages/anagrafica-filiere/filiere.routes').then(
        (m) => m.FiliereRoutes
      ),
      canActivate: [keycloakGuard]
  },
    {
    path: 'impostazioni',
    component: FullComponent,
    loadChildren: () =>
      import('./pages/settings/settings.routes').then(
        (m) => m.SettingsRoutes
      ),
      canActivate: [keycloakGuard]
  },
  {
    path: 'login_success',
    component: BlankComponent,

        loadChildren: () =>
          import('./shared/login-success/login-success.routes').then(
            (m) => m.LoginSuccessRoutes
          ),
/*     canActivate: [keycloakGuard] */

  },
  {
    path: 'help',
    component: FullComponent,
    loadChildren: () =>
      import('./pages/psa/components/help-section/help-section.routes').then(
        (m) => m.HelpSectionRoutes
      ),
    canActivate: [keycloakGuard]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },

];
